import React from "react";
import boyimg from "../../assets/images/newboy.png"
import girlimg from "../../assets/images/newgirl.png"
import styles from "./typewriter.module.css";
const Typewriter = () => {
    return (
        <div className={styles.typeContainer}>
            <div className={styles.girlimgContainer}>
                <img className={styles.girlimg} src={girlimg} alt="girlimg" />
            </div>
            <div className={styles.typewriterEffect}>
                <h1 className={styles.typeTextCon} aria-label="Hi! I'm a developer">
                    <h1 className={styles.typeText}>آماده‌ ای برای...</h1>
                    &nbsp;<span className={styles.typewriter}></span>
                </h1>
            </div>
            <div className={styles.boyimgContainer}>
                <img className={styles.boyimg} src={boyimg} alt="boyimg" />
            </div>
        </div>
    )
}
export default Typewriter;